// The sticky save bar shared by both editor tabs: status dot + bold state text + explainer sub
// line on the left, Reset (text button) + primary Save on the right. `tone` drives the dot —
// 'dirty' is accented; 'clean' and 'new' stay grey. `live` arms the save button in the reserved
// warm tone (Processing tab in live mode).
export default function SaveBar({
	tone = 'clean',
	statusText,
	sub,
	errors = [],
	onReset,
	onSave,
	resetDisabled,
	saveDisabled,
	saving,
	saveLabel = 'Save changes',
	live,
}) {
	return (
		<div className="js-savebar">
			<div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0 }}>
				<span className={`js-dirty-dot${tone === 'dirty' ? ' is-dirty' : ''}`}>{statusText}</span>
				{sub ? <span className="js-muted">{sub}</span> : null}
				{errors.length > 0 && (
					<div className="js-validation">
						{errors.slice(0, 3).map((e, i) => (
							// eslint-disable-next-line react/no-array-index-key
							<span key={i}>• {e.message}</span>
						))}
						{errors.length > 3 && <span className="js-muted">+{errors.length - 3} more</span>}
					</div>
				)}
			</div>
			<div style={{ display: 'flex', gap: 8 }}>
				<button type="button" className="js-btn js-btn-text" onClick={onReset} disabled={resetDisabled || saving}>
					Reset
				</button>
				<button
					type="button"
					className={`js-btn js-btn-primary${live ? ' js-btn-live' : ''}`}
					onClick={onSave}
					disabled={saveDisabled || saving}
				>
					{saving ? 'Saving…' : saveLabel}
				</button>
			</div>
		</div>
	);
}
